export class TipoGrupoFluxo {
  id: number;
  descricao: string;

  constructor(tipoGrupoFluxo?: TipoGrupoFluxo | number) {
    if (tipoGrupoFluxo !== undefined && tipoGrupoFluxo !== null) {
      if (typeof tipoGrupoFluxo === 'number') {
        this.id = tipoGrupoFluxo;
      } else {
        this.id = tipoGrupoFluxo.id;
        this.descricao = tipoGrupoFluxo.descricao;
      }
    }
  }
}
